<app-basic-page [pageTitle]="'History'">
  @if (credits() < 10) {
    <nz-alert
      nzType="warning"
      nzMessage="Your balance is insufficient to launch an session. You can buy more points or refer friends to earn points."
      nzShowIcon
    ></nz-alert>
  }

  <div class="basic-block">
    <div class="horizontal seperate balance">
      <div class="vertical">
        <div class="section-title">Your Balance</div>
        <div class="horizontal bottom">
          @if (credits() < 10) {
            <div class="credits" [ngStyle]="{ color: '#f24647' }">{{ credits() }}</div>
          } @else {
            <div class="credits">{{ credits() }}</div>
          }
          <div class="points-text">Points</div>
        </div>
      </div>
      <div class="vertical-large buttons">
        <button nz-button nzType="default" nzSize="default" (click)="onReferToWinPointsClick()">
          Refer to Win Points
        </button>

        <button nz-button nzType="primary" nzSize="default" (click)="onBuyMorePointsClick()">Buy More Points</button>
      </div>
    </div>
  </div>

  <div class="basic-block">
    <div class="horizontal seperate balance">
      <div class="vertical">
        <div class="section-title">History</div>
      </div>
    </div>

    <nz-table #historyTable [nzData]="creditHistoryList()" [nzPaginationType]="'small'" [nzPageSize]="8">
      <thead>
        <tr>
          <th>Event</th>
          <th [nzAlign]="'center'">Points</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        @for (data of historyTable.data; track data.id; let i = $index) {
          <tr>
            <td>{{ getTitle(data) }}</td>
            <td [nzAlign]="'center'">{{ data.subData.diffCredits }}</td>
            <td>{{ data.createdTime | toLocaleFormat: 'ff' }}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
</app-basic-page>

<app-text-image-modal
  [(isVisible)]="isReferVisible"
  title="Refer & Earn 10 Points!"
  content="Invite your friends to join by entering their email addresses. When your friends sign up from the invitation email, both of you will earn 10 points each."
  imageSrc="/assets/images/vector-illustrations/refer.png"
  okText="Invite"
  (okClick)="onInviteClick()"
  cancelText="Remind me next time"
>
  <input nz-input placeholder="Email" [(ngModel)]="inviteEmail" />
</app-text-image-modal>
